// extracted by mini-css-extract-plugin
export default {"paragraph":"d2tFU9"};